// Content registry: maps group/service slugs to their rich page content.
// Add a page = add a content module and register it here. The layouts read
// from these; if no entry exists, the page renders a "coming soon" stub.

// Skilled Migration
import skilledMigrationHub from "./skilled-migration-hub";
import skilledIndependent189 from "./skilled-independent-189";
import skilledNominated190 from "./skilled-nominated-190";
import skilledRegional491 from "./skilled-regional-491";
import permanentRegional191 from "./permanent-regional-191";
import skillsAssessment from "./skills-assessment";

// Employer Sponsored
import employerSponsoredHub from "./employer-sponsored-hub";
import skillsInDemand482 from "./skills-in-demand-482";
import employerNomination186 from "./employer-nomination-186";
import regional494 from "./regional-494";

// Family & Partner
import familyPartnerHub from "./family-partner-hub";
import partnerVisa from "./partner-visa";
import prospectiveMarriage300 from "./prospective-marriage-300";
import parentVisa from "./parent-visa";
import childVisa from "./child-visa";

// Student & Graduate
import studentGraduateHub from "./student-graduate-hub";
import student500 from "./student-500";
import studentVisaExtension from "./student-visa-extension";
import changeOfCourse from "./change-of-course";
import graduate485 from "./graduate-485";
import admissions from "./admissions";
import oshc from "./oshc";

// Visitor & Working Holiday
import visitorWorkingHolidayHub from "./visitor-working-holiday-hub";
import visitor600 from "./visitor-600";
import sponsoredFamilyVisitor from "./sponsored-family-visitor";
import workingHoliday from "./working-holiday";

// Business & Investment
import businessInvestmentHub from "./business-investment-hub";
import businessInvestmentAdvisory from "./business-investment-advisory";

// Review & Appeals
import reviewAppealsHub from "./review-appeals-hub";
import visaRefusals from "./visa-refusals";
import visaCancellations from "./visa-cancellations";

// Hub content keyed by group slug.
const hubContent = {
  "skilled-migration": skilledMigrationHub,
  "employer-sponsored": employerSponsoredHub,
  "family-partner": familyPartnerHub,
  "student-graduate": studentGraduateHub,
  "visitor-working-holiday": visitorWorkingHolidayHub,
  "business-investment": businessInvestmentHub,
  "review-appeals": reviewAppealsHub,
};

// Service content keyed by "groupSlug/serviceSlug".
const serviceContent = {
  // Skilled Migration
  "skilled-migration/skilled-independent-189": skilledIndependent189,
  "skilled-migration/skilled-nominated-190": skilledNominated190,
  "skilled-migration/skilled-regional-491": skilledRegional491,
  "skilled-migration/permanent-regional-191": permanentRegional191,
  "skilled-migration/skills-assessment": skillsAssessment,
  // Employer Sponsored
  "employer-sponsored/skills-in-demand-482": skillsInDemand482,
  "employer-sponsored/employer-nomination-186": employerNomination186,
  "employer-sponsored/regional-494": regional494,
  // Family & Partner
  "family-partner/partner-visa": partnerVisa,
  "family-partner/prospective-marriage-300": prospectiveMarriage300,
  "family-partner/parent-visa": parentVisa,
  "family-partner/child-visa": childVisa,
  // Student & Graduate
  "student-graduate/student-500": student500,
  "student-graduate/student-visa-extension": studentVisaExtension,
  "student-graduate/change-of-course": changeOfCourse,
  "student-graduate/graduate-485": graduate485,
  "student-graduate/admissions": admissions,
  "student-graduate/oshc": oshc,
  // Visitor & Working Holiday
  "visitor-working-holiday/visitor-600": visitor600,
  "visitor-working-holiday/sponsored-family-visitor": sponsoredFamilyVisitor,
  "visitor-working-holiday/working-holiday": workingHoliday,
  // Business & Investment
  "business-investment/business-investment-advisory": businessInvestmentAdvisory,
  // Review & Appeals
  "review-appeals/visa-refusals": visaRefusals,
  "review-appeals/visa-cancellations": visaCancellations,
};

export const getHubContent = (groupSlug) => hubContent[groupSlug] || null;

export const getServiceContent = (groupSlug, serviceSlug) =>
  serviceContent[`${groupSlug}/${serviceSlug}`] || null;
